import { FeatureFlagType } from '../../enums/feature-flag-type';
import { ScoreComparison } from '../../enums/score-comparison';

export interface CompanyVariables {
  slug: string | undefined;
  name: string | undefined;
  useLevels: boolean;
  minLevel: number;
  maxLevel: number;
  scoreComparison: ScoreComparison;
  displayJobInformationForm: boolean;
  allowOffPlatformLearning: boolean;
  allowReflections: boolean;
  showCertificates: boolean;
  downloadLearningProgressPdf: boolean;
  showPoweredByLogo: boolean;
  hasLearningPlatformIntegration: boolean;
  featureFlags: FeatureFlagType[];
}

export const defaultCompanyVariables: CompanyVariables = {
  slug: undefined,
  name: undefined,
  minLevel: 1,
  maxLevel: 7,
  useLevels: true,
  displayJobInformationForm: true,
  allowOffPlatformLearning: false,
  allowReflections: false,
  showCertificates: false,
  downloadLearningProgressPdf: true,
  showPoweredByLogo: false,
  hasLearningPlatformIntegration: false,
  scoreComparison: ScoreComparison.None,
  featureFlags: []
};
